import type { ObjectContext, VuexStateContext, VuexActionContext, VuexParamsContext } from '@/global'
// import modules from './modules'

export default {
	// modules: modules,
	namespaced: true,
	state: {
		item: {},
		list: []
	},
	getters: {
		GET_ITEM(state: VuexStateContext) {
			return state.item
		}
	},
	mutations: {
		SET_ITEM(state: VuexStateContext, value: ObjectContext) {
			state.item = Object.assign({}, value)
		},
		SET_LIST(state: VuexStateContext, value: Array<object>) {
			state.list = JSON.parse(JSON.stringify(value))
		}
	},
	actions: {
		async getList({ commit, dispatch }: VuexActionContext, params: VuexParamsContext): Promise<any> {
			const obj: ObjectContext = params || {}
			if (!obj.query) obj.query = {}

			try {
				const body: ObjectContext = {
					...obj,
					return_type: 'warehouse_evaluations'
				}
				commit('SET_LIST', [])
				// @ts-ignore
				const res = await this.$axios.post('query/warehouse_evaluations', body)
				const data = res.data.response_json
				const items = data['warehouse_evaluations']
				commit('SET_LIST', items)
				return data
			} catch (error) {
				dispatch('alert/SET_ALERT', { action: 'get', error }, { root: true })
			}
		},
		async get({ commit }: VuexActionContext, id: number): Promise<ObjectContext> {
			// @ts-ignore
			const res = await this.$axios.get(`warehouse_evaluations/${id}`)
			const data = res.data.response_json
			commit('SET_ITEM', data)
			return res.data.response_json
		},
		async create(ctx: VuexActionContext, params: VuexParamsContext): Promise<ObjectContext> {
			const body: ObjectContext = Object.assign({}, params)
			body.warehouse_evaluation_crop_water_quantity = 100
			body.warehouse_evaluation_crop_electricity_quantity = 100
			body.warehouse_evaluation_crop_machinery_quantity = 100
			// @ts-ignore
			return await this.$axios.post('warehouse_evaluations', body)
		},
		async update({ commit }: VuexActionContext, params: VuexParamsContext): Promise<ObjectContext> {
			const keys: Array<string> = params._keys
			const item = Object.assign({}, params._item)
			let body: ObjectContext = {}
			keys ? keys.forEach(e => (body[e] = item[e])) : (body = Object.assign({}, params))
			delete body._item
			delete body.associated_files
			// @ts-ignore
			const res = await this.$axios.patch(`warehouse_evaluations/${item.warehouse_evaluation_id}`, body)
			const data = res.data.response_json
			commit('SET_ITEM', data)
			return res
		},
		async delete(ctx: VuexActionContext, params: VuexParamsContext): Promise<ObjectContext> {
			// @ts-ignore
			return await this.$axios.delete(`warehouse_evaluations/${params.warehouse_evaluation_id}`)
		}
	}
}
